/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Natálie Witová',
    email: 'natalie.witova@salonwitova.com',
    avatar: 'images/avatars/natalie.png',
    status: 'online',
};
